/**
 * @deprecated Use `@/features/auth/api/auth.api` instead.
 * This file is a compatibility shim during the SPA migration.
 * All Server Action logic has been moved to client-side API functions.
 */

// Re-export everything from the new API module
export {
  signupUserStep1,
  signupUserStep1Complete,
  getRegistrationProgress,
  loginUser,
  sendLoginOtp,
  VerifyOtp,
  forgotPassword,
  resetPassword,
  isEmailExists,
  getGoogleAuthUrl,
} from "../api/auth.api"

import { clearAccessToken, getAccessToken } from "@/shared/lib/auth-fetch"
import { Session } from "@/shared/types/session.type"

const BASE_URL = process.env.NEXT_PUBLIC_BASE_BACKEND_URL as string

/**
 * Compatibility wrapper to retrieve the current session by decoding
 * the in-memory access token.
 */
export async function verifySession(): Promise<Session | null> {
  const token = getAccessToken()
  if (!token) return null
  try {
    const payload = JSON.parse(
      atob(token.split(".")[1].replace(/-/g, "+").replace(/_/g, "/")),
    )
    return payload as Session
  } catch {
    return null
  }
}

/** Retrieve the current session */
export async function getSession(): Promise<Session | null> {
  return verifySession()
}

/**
 * @deprecated Auth cookie is now an httpOnly refresh token managed by the backend.
 * Access tokens are stored in-memory via auth-fetch. This function is a no-op.
 */
export async function setAuthCookie(_token: string) {
  // No-op in SPA mode — token is stored in-memory by auth-fetch
}

/**
 * @deprecated Use `useSession().logout()` instead.
 */
export async function logoutUser() {
  try {
    await fetch(`${BASE_URL}/auth/logout`, {
      method: "POST",
      credentials: "include",
    })
  } catch {
    // Non-fatal
  }
  clearAccessToken()
}

/** @deprecated Not needed in SPA mode. */
export async function registerUser(_email: string) {
  console.warn("[DEPRECATED] registerUser() — not needed in SPA mode.")
  return { success: false, message: "Deprecated" }
}

/** @deprecated Google OAuth is now handled via direct URL redirect. Use getGoogleAuthUrl(). */
export async function googleAuth() {
  console.warn("[DEPRECATED] googleAuth() — use getGoogleAuthUrl() instead.")
}

/** @deprecated Google OAuth callback is handled by the backend. */
export async function googleAuthCallback() {
  console.warn("[DEPRECATED] googleAuthCallback() — handled by backend.")
}